import styled from 'styled-components';

const Separator = styled.div`
  width: 100%;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  height: 1px;
  opacity: 0.24;
`;

export default Separator;
